import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
const styles = StyleSheet.create({
  container: {
    flex: 3,
    marginVertical: 32
  }
});
export default /*#__PURE__*/memo(_ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(View, {
    style: styles.container,
    key: 'full-app-main-view'
  }, children);
});
//# sourceMappingURL=MainSection.js.map